import { render } from "./ButtonConfirm.vue?vue&type=template&id=af636f5e&scoped=true"
import script from "./ButtonConfirm.vue?vue&type=script&lang=js"
export * from "./ButtonConfirm.vue?vue&type=script&lang=js"

import "./ButtonConfirm.vue?vue&type=style&index=0&id=af636f5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af636f5e"]])

export default __exports__